import type { ISVG } from "./UrlIcon";

export interface ICompressingIconProps extends ISVG {}

export const CompressingIcon = ({ width: _width, height: _height, fill: _fill, className }: ICompressingIconProps) => {
    const width = _width ?? 27;
    const height = _height ?? 24;

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 27 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className || "fill-white"}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.06521 2.1733C5.02075 2.23561 5.00932 2.3082 5.03126 2.37655C5.74696 4.61219 6.95598 8.82853 6.95598 12C6.95598 15.1715 5.74721 19.387 5.03151 21.6227C5.00957 21.691 5.02075 21.7644 5.06521 21.8267C5.10845 21.8873 5.16382 21.913 5.22285 21.913H21.2108C21.2702 21.913 21.3255 21.8872 21.3686 21.8268C21.4128 21.7648 21.4245 21.6922 21.4024 21.6232C20.6867 19.3876 19.4777 15.1715 19.4777 12C19.4777 8.82853 20.6865 4.61297 21.4022 2.37733C21.4241 2.30898 21.4129 2.23561 21.3685 2.1733C21.3252 2.11269 21.2699 2.08696 21.2108 2.08696H5.22285C5.16382 2.08696 5.10845 2.11269 5.06521 2.1733ZM3.04392 3.01362C2.5772 1.5579 3.64462 0 5.22285 0H21.2108C22.7893 0 23.8569 1.55845 23.3895 3.0144C22.6687 5.2662 21.5647 9.1944 21.5647 12C21.5647 14.8057 22.6688 18.7341 23.3896 20.9858C23.8568 22.4423 22.7892 24 21.2108 24H5.22285C3.64462 24 2.5772 22.4421 3.04392 20.9864C3.76474 18.7347 4.86902 14.8059 4.86902 12C4.86902 9.1942 3.76475 5.26534 3.04392 3.01362Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.417453 5.68696C0.878491 5.34118 1.53254 5.43461 1.87832 5.89565C2.47789 6.69507 2.81928 7.7953 3.01933 8.83555C3.2246 9.90299 3.30441 11.036 3.30441 12C3.30441 12.964 3.2246 14.097 3.01933 15.1645C2.81928 16.2047 2.47789 17.3049 1.87832 18.1043C1.53254 18.5654 0.878491 18.6588 0.417453 18.313C-0.043585 17.9673 -0.137021 17.3132 0.208757 16.8522C0.522235 16.4342 0.789538 15.7083 0.969924 14.7703C1.14508 13.8595 1.21745 12.8621 1.21745 12C1.21745 11.1379 1.14508 10.1405 0.969924 9.22967C0.789538 8.29166 0.522235 7.5658 0.208757 7.14783C-0.137021 6.68679 -0.043585 6.03273 0.417453 5.68696Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.5218 6.82609C8.5218 6.24979 8.98898 5.78261 9.56528 5.78261H16.8696C17.4459 5.78261 17.9131 6.24979 17.9131 6.82609C17.9131 7.40238 17.4459 7.86956 16.8696 7.86956H9.56528C8.98898 7.86956 8.5218 7.40238 8.5218 6.82609Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.5218 12C8.5218 11.4237 8.98898 10.9565 9.56528 10.9565H16.8696C17.4459 10.9565 17.9131 11.4237 17.9131 12C17.9131 12.5763 17.4459 13.0435 16.8696 13.0435H9.56528C8.98898 13.0435 8.5218 12.5763 8.5218 12Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.5218 16.8696C8.5218 16.2933 8.98898 15.8261 9.56528 15.8261H12.0001C12.5764 15.8261 13.0435 16.2933 13.0435 16.8696C13.0435 17.4459 12.5764 17.913 12.0001 17.913H9.56528C8.98898 17.913 8.5218 17.4459 8.5218 16.8696Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.0175 5.68696C26.4785 6.03274 26.5719 6.68679 26.2261 7.14783C25.9127 7.5658 25.6454 8.29166 25.465 9.22967C25.2898 10.1405 25.2175 11.1379 25.2175 12C25.2175 13.704 25.5 15.3623 26.3247 17.0116C26.5824 17.5271 26.3735 18.1538 25.858 18.4116C25.3426 18.6693 24.7158 18.4604 24.4581 17.9449C23.4566 15.942 23.1305 13.9482 23.1305 12C23.1305 11.036 23.2103 9.90299 23.4156 8.83555C23.6156 7.7953 23.957 6.69507 24.5566 5.89565C24.9024 5.43461 25.5564 5.34118 26.0175 5.68696Z"
            />
        </svg>
    );
};
